import Spline from '@splinetool/react-spline';
import "./NotFound.css";
import React from 'react'

function Notfound() {
  return (
    <div className='NotFound'>
        <Spline 
        
        scene='https://prod.spline.design/s-Ju3hpzU123GPax/scene.splinecode'
        />
    </div>
  )
}

export default Notfound